import styled from 'styled-components';

export const DonationsSection = styled.div``;

export const DonationsTitle = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;

    @media screen and (max-width:1199px) {
        font-size: 35px;
        line-height: 40px;
    }
    @media screen and (max-width:991px) {
        font-size: 30px;
        line-height: 35px;
    }
    @media screen and (max-width:575px) {
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 20px;
    }
`;

export const DonationsTotal = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px; 

    @media screen and (max-width: 480px){
        align-items: flex-start;
        margin-bottom: 23px;
        flex-direction: column;
        row-gap: 15px
    }

    .DateInput,
    .DateRangePicker{
        background-color: #F9DC70;
        border-radius: 10px;
    }
    
    .DateRangePickerInput__withBorder{
        background-color: #F9DC70;
        border-radius: 10px;
    }

    .DateInput_input{
        background-color: #F9DC70;
        font-size: 18px;
        color: #333333;
        font-weight: 400;
        font-family: 'Jost', sans-serif;
        border-radius: 10px;
        border-bottom: none;
        cursor: pointer;
    }
input#your_unique_start_date_id {
    padding-left: 13px;
}
    .CalendarDay__selected, .CalendarDay__selected:active, .CalendarDay__selected:hover{
        background: #01606f;
        border: 1px double #f9dc70;
        color: #fff;
    }
    .CalendarDay__selected_span{
        background: #f9dc70;
        border: 1px double #f9dc70;
        color: #01606f;
    }

    .CalendarMonth.CalendarMonth_1{
        padding: 0px 5px !important;
    }
    .DateRangePicker_picker{
        margin-left: -330px;

    @media screen and (max-width:575px){
            margin-left: 0;
            width: 318px;
            overflow: scroll;
        }
    }

`;

export const TotalTile = styled.h2`
    color:#333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 0px; 
    
    @media screen and (max-width:575px) {
        font-size: 20px;
        line-height: 35px;
    }
`;

export const TotalTileSpan = styled.span`
    color:#333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 0px; 
    
    @media screen and (max-width:575px) {
        font-size: 20px;
        line-height: 35px;
    }
`;

export const DonationsFoundation = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:20px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom:20px;
    &:last-child{
        margin-bottom:0px;
    }
`;

export const FoundationText = styled.div`
 
`;
export const FoundationAmount = styled.div`
    color:#01606F;
    font-family: "Jost", sans-serif;
    font-size:24px;
    font-weight: bold;
    line-height: 75px;
    margin-bottom: 0px;

    @media screen and (max-width:575px) {
         font-size:20px;
    }
`;

export const FoundationTitle = styled.h2`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 30px;
    margin-bottom: 5px; 
`;

export const FoundationDate = styled.span`
    color:#333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 400;
    line-height: 30px;
    margin-bottom: 0px;
`;


export const Downloadatebtn = styled.div`
    display: flex;
    gap: 10px;
`;

export const Giveagain = styled.div`
 .give-btn{
    background: #01606F 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 20px #0000001A;
    border-radius: 10px;
    opacity: 1;
    border: none;
    padding: 7px 17px;
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 23px;

     &:active{
       background: #01606F 0% 0% no-repeat padding-box;
      }   
      &:focus-visible{
     box-shadow:none;
      } 
  }
`;


export const CheckTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    h2{
      margin-bottom:0;
    }
`;